"use client";

type Props = {
  bpm: number;
  onChange: (bpm: number) => void;
  disabled?: boolean;
  ariaLabel?: string;
};

export const MIN_BPM = 40;
export const MAX_BPM = 240;

const clampBpm = (value: number) => Math.max(MIN_BPM, Math.min(MAX_BPM, Math.round(value)));

export function BpmNumberInput({ bpm, onChange, disabled = false, ariaLabel = "BPM数値" }: Props) {
  function update(value: string) {
    const parsed = Number(value);
    if (Number.isFinite(parsed) && parsed >= MIN_BPM && parsed <= MAX_BPM) onChange(Math.round(parsed));
  }

  function commit(input: HTMLInputElement) {
    const parsed = Number(input.value);
    const next = clampBpm(Number.isFinite(parsed) && input.value ? parsed : bpm);
    input.value = String(next);
    onChange(next);
  }

  return <input
    key={bpm}
    aria-label={ariaLabel}
    type="number"
    inputMode="numeric"
    min={MIN_BPM}
    max={MAX_BPM}
    step="1"
    defaultValue={bpm}
    disabled={disabled}
    onChange={(event) => update(event.target.value)}
    onBlur={(event) => commit(event.currentTarget)}
    onKeyDown={(event) => { if (event.key === "Enter") event.currentTarget.blur(); }}
  />;
}
